import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultComponent } from './layouts/default/default.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { MyaccountComponent } from './layouts/myaccount/myaccount.component';
import { ProfileComponent } from './profile/profile.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { OrdersComponent } from './orders/orders.component';
import { ContactComponent } from './contact/contact.component';
import { ProductsComponent } from './products/products.component';
import { ProductComponent } from './products/product/product.component';
import { ProjectsComponent } from './projects/projects.component';
import { ProjectComponent } from './projects/project/project.component';
import { BlogsComponent } from './blogs/blogs.component';
import { PostComponent } from './blogs/post/post.component';
import { CartComponent } from './cart/cart.component';
import { CheckOutComponent } from './check-out/check-out.component';
import { SignupComponent } from './signup/signup.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { CalculatorComponent } from './calculator/calculator.component';
import { ReferAppComponent } from './refer-app/refer-app.component';
import { ReferProductComponent } from './refer-product/refer-product.component';
import { ReplacementComponent } from './replacement/replacement.component';
import { TrackOrderComponent } from './track-order/track-order.component';
import { RateProductComponent } from './rate-product/rate-product.component';
import { AuthGuard } from './shared/services/auth-guard.service';
import { ServicesComponent } from './services/services.component';

const routes: Routes = [
  {path:'',component:DefaultComponent,
    children:[
      {path:'',component:HomeComponent},
      {path:'about-us',component:AboutComponent},
      {path:'contact-us',component:ContactComponent},
      {path:'collections/:category',component:ProductsComponent},
      {path:'collections/:category/:id',component:ProductComponent},
      {path:'projects/:type',component:ProjectsComponent},
      {path:'projects/:type/:id',component:ProjectComponent},
      {path:'blogs',component:BlogsComponent},
      {path:'blogs/:id',component:PostComponent},
      {path:'cart',component:CartComponent},
      {path:'check-out',component:CheckOutComponent},
      {path:'login',component:AuthenticationComponent},
      {path:'signup',component:SignupComponent},
      {path:'forgot',component:ForgotPasswordComponent},
      {path:'calculator',component:CalculatorComponent},
      {path:'myaccount/orders',component:OrdersComponent},
      {path:'refer-app',component:ReferAppComponent},
      {path:'refer-product',component:ReferProductComponent},
      {path:'myaccount/replacement',component:ReplacementComponent},
      {path:'myaccount/track-order',component:TrackOrderComponent},
      {path:'myaccount/rate-product',component:RateProductComponent},
      {path:'services',component:ServicesComponent}
    ]
  },
  {path:'',component:MyaccountComponent,
    children:[
     {path:'myaccount/profile',component:ProfileComponent, canActivate:[AuthGuard]},
     {path:'myaccount/change-password',component:ChangePasswordComponent}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
